export default __webpack_public_path__ + "static/media/pci-logo.604dc226.png";